<template>
  <div>
    <div class="index" v-if="!detail.show">
      <div class="title">
        <div class="span1">
          <span>机构信息</span>
        </div>
      </div>

      <div>
        <el-form :model="queryParams">
          <div class="title_samll">
            <div class="title_mage">
              <img src="@/assets/img/peple.png" alt="" />
            </div>
            <div class="title_msg">账号信息</div>
          </div>
          <el-form-item label="姓名">
            <!-- <el-input
              v-model="queryParams.name"
              placeholder="请输入"
              :disabled="true"
            ></el-input> -->
            <span> {{ queryParams.name || "无" }} </span>
          </el-form-item>
          <!-- <el-form-item label="身份证号">
            <span> {{ queryParams.card_code || "无" }} </span>
          </el-form-item>
          <el-form-item label="邮箱">
            <span> {{ queryParams.email || "无" }} </span>
          </el-form-item> -->
          <el-form-item label="手机号">
            <span> {{ queryParams.phone || "无" }} </span>
          </el-form-item>
          <div class="title_samll border_top">
            <div class="title_mage">
              <img src="@/assets/img/list.png" alt="" />
            </div>
            <div class="title_msg">机构主体信息</div>
          </div>
          <el-form-item label="机构名称">
            <span> {{ info.org_name || "无" }} </span>
          </el-form-item>
          <el-form-item label="执照代码">
            <span> {{ info.org_social_credit_code || "无" }} </span>
          </el-form-item>
          <el-form-item label="培训形式">
            <span> {{ businessType | businessTypeFilter }} </span>
          </el-form-item>
          <el-form-item label="培训类型">
            <span> {{ subject | subjectFilter }} </span>
          </el-form-item>
          <el-form-item label="培训学段">
            <span> {{ object | objectFilter }} </span>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getOrgInfo,
  getUserInfo,
  getMemberInfo,
  getAllAreaInfo,
  getOrgPrivacyInfo,
  getUserLevel,
} from "@/api/user/userCenter";
import { handleGetCorpStatus } from "@/api/register/index.js";
export default {
  props: ["info"],
  data() {
    return {
      businessType: "", //培训形式
      subject: "", //培训类型
      object: "", //培训学段
      queryParams: {
        name: "",
        email: "",
        org_name: "",
        org_short_name: "",
        org_telephone: "",
        org_address: "",
        org_category_title: "",
        card_code: "",
        phone: "",
        org_code_certificate: "", //组织机构认证代码
        school_legal_person_name: "", //法人代表姓名
      },
      detail: {
        info: { title: "赵兵 9月课酬详情" },
        show: false,
      },
    };
  },
  watch: {
    "info.org_id": function(n, o) {
      this.getOrgInfoMW();
      this.initData();
    },
  },
  created() {
    this.initData();
    this.getOrgInfoMW();
  },

  filters: {
    businessTypeFilter(type) {
      const typeMap = {
        0: "线上",
        1: "线下    ",
      };
      return typeMap[type] || "无";
    },
    subjectFilter(type) {
      const typeMap = {
        0: "非学科",
        1: "学科    ",
      };
      return typeMap[type] || "无";
    },
    objectFilter(type) {
      if (type) {
        let typeArr = type.split(",");
        let objectArr = [];
        const typeMap = {
          0: "学龄前",
          1: "义务教育阶段    ",
          2: "高中阶段    ",
          3: "成人    ",
          4: "中职    ",
        };
        typeArr.forEach((it) => {
          objectArr.push(typeMap[it]);
        });
        return objectArr.join(" , ");
      } else {
        return "无";
      }
    },
  },
  methods: {
    async initData() {
      // console.log("获取机构详情信息111111111", this.info);
      let paramsData = {
        user_id: this.info.create_user_id,
        top_org_id: this.info.org_id,
      };
      getMemberInfo(paramsData).then((res) => {
        // console.log("用户中心获取用户信息----", res);
        if (res.code == "000000") {
          this.queryParams.name = res.result.name;
          this.queryParams.email = res.result.email;
          this.queryParams.card_code = res.result.card_code;
          this.queryParams.phone = res.result.phone;
        }
      });
      // let params = {
      //   org_id: this.info.org_id, //机构、学校等组织id
      //   field:
      //     "org_code_certificate,org_address,school_legal_person_name,school_legal_person_code,org_telephone,org_social_credit_code", //是否查更多详情(1要查，0不查)默认不查
      // };
      // const { code, result } = await getOrgInfo(params);
    },
    async getOrgInfoMW() {
      const { creditCode } = await getOrgPrivacyInfo({
        orgId: this.info.org_id, //机构名称
        privacy: "3", //组织统一社会信用代码
      });
      // console.log("获取机构信息--信用代码---", creditCode);
      if (creditCode) {
        this.getCorpStatus(creditCode);
      }
    },
    //查询机构状态
    async getCorpStatus(code) {
      let params = {
        corpName: this.info.org_name, //机构名称
        certificateNo: code, //组织统一社会信用代码
      };
      const { retCode, data, retDesc } = await handleGetCorpStatus(params);
      console.log("查询机构状态---", data);
      if (retCode === "000000" && data) {
        this.businessType = data.businessType;
        this.subject = data.subject;
        this.object = data.object;
      } else {
        console.error(retDesc);
      }
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }
  .border_top {
    border-top: 1px solid #eaeaea;
  }
  .title_samll {
    margin: 20px 0;
    padding-top: 20px;
    display: flex;
    justify-content: left;
    align-items: center;
    .title_mage {
      margin-right: 15px;
    }
    .title_msg {
      margin-bottom: 3px;
    }
    img {
      width: 16px;
      height: 16px;
    }
    span {
      margin-bottom: 5px;
      margin-left: 10px;
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 14px;
      text-align: left;
      color: #181c26;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 400px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
  .el-input {
    width: 200px;
  }
  .el-form-item {
    margin-bottom: 22px;
    margin-left: 33px;
  }
}
</style>
